<template>
  <span>
    <span style="margin-right: 0.05rem;">
      <el-select v-model="carItem.trafficType" class="typeParent" placeholder="请选择" size="mini" @change="getBusType(carItem.trafficType)">
        <el-option v-for="text in busOptionOne" :key="text" :label="text" :value="text"></el-option>
      </el-select>
    </span>
    <template v-if="carItem.trafficType&&carItem.trafficType!=''">
      <span style="margin-right: 0.05rem;">
        <el-select v-model="carItem.busType" placeholder="请选择" size="mini" style="width: 2.4rem;" class="typeSon" @change="changeBusType">
          <el-option v-for="item in busTypeOption" :key="item.categorySonNameCn" :label="item.categorySonNameCn" 
            :value="item">
          </el-option>
        </el-select>
      </span>
      <span style="margin-right: 0.05rem;">
        <el-input v-model="carItem.busNumber" placeholder="请填写" style="width:0.9rem" size="mini" class="busNumber"
          @input="carItem.busNumber=carItem.busNumber.replace(/[^\d]/g,'')">
        </el-input>
        &nbsp;<b>辆</b>
      </span>
    </template>
  </span>
</template>

<script>
import Api from '@/components/Api/index.js'
export default {
  props:{
    carItem:{
      type:Object,
      default:()=>{return {}}
    },
  },
  data(){
    return{
      busOptionOne: ['司机兼向导（一般为9座车以下）', '大车（含司机）加导游', '大车（含司机）不需要导游'],
      busTypeOption: [],
    }
  },
  methods:{
    changeBusType(item){
      this.carItem.busType=item.categorySonNameCn
      this.carItem.busTypeEn=item.categorySonNameEn
    },
    getBusType (data,type) {
      let obj = {page: 1,q: { molds:type?[18]:data == '司机兼向导（一般为9座车以下）' ? [43] : [33]},size: 100}
      new Api('resource').getResourceType(obj).then(res => {
        if (res.status == 200) {
          if(type){
            res.data.records.forEach(e=>{
              this.charactOptionOne.push(e.categorySonNameCn)
            })
            console.log(this.charactOptionOne)
          }else{
            this.busTypeOption = res.data.records
          }
        }
      })
    },
  }
}
</script>

<style>

</style>